export const ignoredErrors = [
  "Can't find variable: gmo",
  "Expected client-id parameter in sdk url",
  "CookieScript is not defined",
  "ResizeObserver is not defined",
  "Failed to fetch",
  "Unexpected end of input",
  "Right-hand side of 'instanceof' is not an object",
  "SQLSTATE[HY000] [2002] Connection refused",
  "Unexpected token 'else'",
  "window.AbortController is not a constructor",
  "n is undefined",
  "Request aborted",
  "Failed to fetch",
  "Envisys-Kontrolldatei fehlt",
  "Request failed with status code 422",
  "Unhandled error response received for message <page-ready>",
  "crypto.randomUUID is not a function",
  "Cannot read properties of null (reading 'sessionId')",
  "TypeError: Load failed"
];

export const denyUrls = [
  /extensions\//i,
  /^chrome-extension:\/\//i,
  /^safari-extension:\/\//i,
  /^ms-browser-extension:\/\//i,
  /^moz-extension:\/\//i,
  /googletagmanager\.com/i,
  /google-analytics\.com/i,
  /doubleclick\.net/i,
  /connect\.facebook\.net/i,
  /ads\.yieldmo\.com/i,
  /adservice\.google\.com/i,
  /platform\.twitter\.com/i,
  /ajax\.googleapis\.com/i,
  /cdnjs\.cloudflare\.com/i,
  /cdn\.jsdelivr\.net/i,
  /code\.jquery\.com/i,
  /widget\.intercom\.io/i,
  /js\.mollie\.com/i,
  /snap\.aksnap\.net/i,
  /cdn\.taboola\.com/i,
  /localhost/i,
  /127\.0\.0\.1/i,
  /0\.0\.0\.0/i,
  /https?:\/\/integrations\.etrusted\.com.*/i,
  /clickcease\.com.*/i
];
